import React from "react";
import SocialMedia from "../components/SocialMedia_NavDots/SocialMedia";
import NavDots from "../components/SocialMedia_NavDots/NavDots";

const AppWrap = (Component, idName, className) =>
  function HOC() {
    return (
      <div id={idName} className={`app__container ${className}`}>
        <SocialMedia />

        <div className="app__wrapper app__flex">
          <Component />

          <div className="copyright">
            <p className="p-text">@{new Date().getFullYear()} Abhishek Nayak</p>
            <p className="p-text">All rights reserved</p>
          </div>
        </div>

        <NavDots active={idName} />
      </div>
    );
  };

export default AppWrap;
